module.exports = __webpack_public_path__ + "img/s2m-loader-small-bw.a77049dc.gif";